module.exports = __webpack_public_path__ + "static/media/carteiras.f1349600.svg";